let interceptorFunction: null

export function setInterceptorFunction(instance: any) {
  interceptorFunction = instance
}

export function interceptor(): any {
  return interceptorFunction
}
